(() => {
  if (window.DRBOAcceleratedConfiguration) return;

  const buildSelection = (state) => {
    const items = state?.items || [];
    if (state?.disabled || !items.length) return null;
    const combined = new Map();
    for (const item of items) {
      const id = Number(item.id);
      const quantity = Number(item.quantity);
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0 || item.available === false) return null;
      if (item.discountCode || item.sellingPlanId || item.selling_plan || item.properties) return null;
      combined.set(id, { id, quantity: (combined.get(id)?.quantity || 0) + quantity });
    }
    return [...combined.values()];
  };

  const writeForm = (form, items) => {
    if (!form || !items) return false;
    const variant = form.elements.namedItem('id');
    if (!(variant instanceof HTMLInputElement || variant instanceof HTMLSelectElement)) return false;
    const previousMain = items.find((item) => String(item.id) === variant.value);
    const main = previousMain || items[0];
    const remaining = items.filter((item) => item.id !== main.id);
    let quantity = form.elements.namedItem('quantity');
    if (!(quantity instanceof HTMLInputElement)) {
      quantity = document.createElement('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      form.appendChild(quantity);
    }
    variant.value = String(main.id);
    if (variant.value !== String(main.id)) return false;
    quantity.value = String(main.quantity);
    let container = form.querySelector('[data-configuration-payment-items]');
    if (!container) {
      container = document.createElement('div');
      container.dataset.configurationPaymentItems = '';
      form.appendChild(container);
    }
    const signature = JSON.stringify(remaining);
    if (container.dataset.selection !== signature) {
      const fragment = document.createDocumentFragment();
      remaining.forEach((item, offset) => {
        for (const key of ['id', 'quantity']) {
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = `shopify-additional-items[${offset + 1}][${key}]`;
          field.value = String(item[key]);
          fragment.appendChild(field);
        }
      });
      container.replaceChildren(fragment);
      container.dataset.selection = signature;
    }
    return true;
  };

  const setAvailability = (container, available) => {
    if (container.hidden === available) container.hidden = !available;
    container.inert = !available;
  };

  const syncSummary = (root, state) => {
    root.drboPurchaseState = state;
    const items = buildSelection(state);
    const busy = root.dataset.standaloneBusy === 'true' || root.dataset.configuratorBusy === 'true' || root.classList.contains('is-price-refreshing');
    const template = root.querySelector('[data-configuration-payment-template]');
    if (template && !root.drboPaymentNode) root.drboPaymentNode = template.content.firstElementChild.cloneNode(true);
    const containers = root.drboPaymentNode ? [root.drboPaymentNode] : root.querySelectorAll('[data-configuration-payment]');
    containers.forEach((container) => {
      const available = !busy && Boolean(items) && writeForm(container.querySelector('form'), items);
      setAvailability(container, available);
      if (template) {
        const slot = root.querySelector('[data-configuration-payment-slot="desktop"]');
        if (slot && container.parentElement !== slot) slot.appendChild(container);
      }
      root.querySelectorAll('[data-summary-purchase="checkout"]').forEach((fallback) => { fallback.hidden = available; });
    });
  };

  const syncNative = (root, state, busy = false) => {
    const section = root.closest('.shopify-section');
    if (!section || root.dataset.linkNativePurchase !== 'true') return;
    const items = buildSelection(state);
    section.querySelectorAll('.product-add-to-cart__additional-buttons').forEach((container) => {
      const native = container.querySelector('.shopify-payment-button');
      if (!native) return;
      const available = !busy && root.dataset.pricingRefreshing !== 'true' && Boolean(items) && writeForm(native.closest('form'), items);
      setAvailability(native, available);
      const wallet = native.querySelector('shopify-accelerated-checkout');
      if (wallet?.hidden) wallet.hidden = false;
      const fallback = container.querySelector('[data-drbo-native-buy]');
      if (fallback) fallback.hidden = available;
    });
  };

  document.addEventListener('drbo:configurator:refreshing', (event) => {
    document.querySelectorAll('[data-drbo-config-summary]').forEach((root) => {
      if (root.dataset.configuratorId !== event.detail?.configuratorId) return;
      root.querySelectorAll('[data-configuration-payment]').forEach((container) => setAvailability(container, false));
    });
  });

  window.DRBOAcceleratedConfiguration = { syncSummary, syncNative, buildSelection, writeForm };
  window.matchMedia('(max-width: 767px)').addEventListener('change', () => {
    document.querySelectorAll('[data-drbo-config-summary]').forEach((root) => {
      if (root.drboPurchaseState) syncSummary(root, root.drboPurchaseState);
    });
  });
  document.querySelectorAll('[data-drbo-config-summary]').forEach((root) => {
    if (root.drboPurchaseState) syncSummary(root, root.drboPurchaseState);
  });
  const state = window.DRBOConfiguratorState;
  const root = state?.configuratorId && document.getElementById(state.configuratorId);
  if (root) syncNative(root, state);
})();
